export default "__VITE_ASSET__CQXhM_Qw__"